import { Observable } from "rxjs/Observable";
import * as Dtos from "src/dtos/Tmd.dtos";
import { client } from "src/dtos/Client";

export const memberStatusesApi = {
    getMemberStatusesByOutlookIds: (outlookIds: string[]): Observable<Dtos.GetMemberStatusesByOutlookIdsResponse> => {
        //Create the request.
        let request: Dtos.GetMemberStatusesByOutlookIds = new Dtos.GetMemberStatusesByOutlookIds({
            outlookIds
        });

        //Send request.
        const response: Promise<Dtos.GetMemberStatusesByOutlookIdsResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
}